import React from "react";
import Flagship from "../../core/flagship";
import { connect } from "react-redux";
import { Link } from "react-router";
import * as actions from "../../actions/appActions";
import LineItemAddModal from "../modals/LineItemAddModal";
import LineItemPricingModal from "../modals/LineItemPricingModal";
import LineItemViewModal from "../modals/LineItemViewModal";
import LineItemEditModal from "../modals/LineItemEditModal";
import {
  getFormattedValue,
  empty,
  getServiceNiceName,
} from "../../utils/helpers";
import {
  Divider,
  Header,
  Loader,
  Card,
  Button,
  Icon,
  Label,
  Table,
  Popup,
  Dropdown,
  Image,
} from "semantic-ui-react";
import { bindActionCreators } from "redux";
import LineItemAssignModal from "../modals/LineItemAssignModal";
import moment from "moment-business-days";

class LineItemBox extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.latestLineItemsRequestId = 0;
    this.unmounted = false;
    this.getLineItems = this.getLineItems.bind(this);
    this.onAddNew = this.onAddNew.bind(this);
    this.cancelAddNew = this.cancelAddNew.bind(this);
    this.closeModals = this.closeModals.bind(this);
    this.renderLineItems = this.renderLineItems.bind(this);
    this.onLineItemAddModalChange = this.onLineItemAddModalChange.bind(this);
    this.onLineItemPricingModalChange =
      this.onLineItemPricingModalChange.bind(this);
    this.onUpdatePricing = this.onUpdatePricing.bind(this);
    this.onViewLineItem = this.onViewLineItem.bind(this);
    this.onEditLineItem = this.onEditLineItem.bind(this);
    this.onAddLineItem = this.onAddLineItem.bind(this);
    this.onUpdateLineItem = this.onUpdateLineItem.bind(this);
    this.swapToEdit = this.swapToEdit.bind(this);
    this.swapToView = this.swapToView.bind(this);
    this.renderAddLineItemModal = this.renderAddLineItemModal.bind(this);
    this.renderPrice = this.renderPrice.bind(this);
    this.maybeOpenLineItem = this.maybeOpenLineItem.bind(this);
    this.duplicateLineItem = this.duplicateLineItem.bind(this);
    this.changeViewAs = this.changeViewAs.bind(this);
    this.renderAsTable = this.renderAsTable.bind(this);
    this.onChangeAssignee = this.onChangeAssignee.bind(this);
    this.onUpdateLineItem = this.onUpdateLineItem.bind(this);
  }

  getInitialState() {
    return {
      loading: true,
      lineItems: [],
      newLineItemName: "",
      newLineItemService: null,
      newLineItemServiceNiceName: null,
      editPricingFields: [],
      addingLineItem: false,
      viewingLineItem: false,
      editingLineItem: false,
      updatingPricing: false,
      newLineItemData: [],
      editingAssignee: false,
      editing: {},
    };
  }

  componentDidMount() {
    this.unmounted = false;
    this.getLineItems();
  }

  componentWillReceiveProps(nextProps) {
    const recordChanged = this.props.recordId !== nextProps.recordId;
    const viewingChildChanged = nextProps.viewingChild !== this.props.viewingChild;

    if (recordChanged) {
      this.props.updateLineItems([]);
      this.setState({
        loading: true,
        lineItems: [],
        viewingLineItem: false,
        editingLineItem: false,
        updatingPricing: false,
        editingAssignee: false,
      });
      this.getLineItems(nextProps.recordId);
    } else if (viewingChildChanged) {
      this.maybeOpenLineItem(nextProps);
    }
  }

  componentWillUnmount() {
    this.unmounted = true;
    this.latestLineItemsRequestId += 1;
  }

  maybeOpenLineItem(nextProps = false) {
    let propsToConsider = nextProps === false ? this.props : nextProps;
    let self = this;
    let viewingNow = false;

    this.state.lineItems.map(function (item) {
      if (item.line_item_key === propsToConsider.viewingChild) {
        viewingNow = true;
        self.setState({
          viewingLineItem: item,
        });
      }
    });
    if (viewingNow !== true) {
      this.setState({
        viewingLineItem: false,
      });
    }
  }

  getLineItems(recordId = this.props.recordId) {
    let self = this;
    this.latestLineItemsRequestId += 1;
    const requestId = this.latestLineItemsRequestId;

    Flagship.get(
      "line-items/" + recordId,
      {},
      function (response) {
        if (
          self.unmounted === true ||
          requestId !== self.latestLineItemsRequestId ||
          self.props.recordId !== recordId
        ) {
          return;
        }

        if (response.data.success === true) {
          let lineItems = Array.isArray(response.data.results)
            ? response.data.results
            : [];
          lineItems.map(function (item) {
            if (!empty(item.flights)) {
              item.flights.sort((a, b) =>
                moment(a.startDate).unix() > moment(b.startDate).unix()
                  ? 1
                  : -1,
              );
            }
          });

          self.setState(
            {
              lineItems,
              loading: false,
            },
            function () {
              if (self.state.lineItems.length) {
                self.props.updateLineItems(self.state.lineItems);

                // See if line items are priced and open view of line item if specified in component props
                let allLineItemsPriced = true;
                self.state.lineItems.map(function (item) {
                  if (item.price === null || item.price === "") {
                    allLineItemsPriced = false;
                  }
                  // Open view of line item if specified in component props
                  self.maybeOpenLineItem();

                  if (item.line_item_key === self.props.viewingChild) {
                    self.setState({
                      viewingLineItem: item,
                    });
                  }
                });
                if (
                  self.props.accessLevel === 2 &&
                  self.props.recordStatus === "publish" &&
                  allLineItemsPriced === true
                ) {
                  // Pricing complete
                  Flagship.event(
                    "pricing-complete-rfp",
                    response.data.results,
                    self.props.recordId,
                    self.props.userId,
                  );
                  Flagship.changeRecordStatus(
                    self.props.recordId,
                    "priced",
                    self.props.onStatusChange,
                  );
                } else if (
                  self.props.accessLevel === 2 &&
                  self.props.recordStatus !== "publish" &&
                  self.props.recordStatus !== "draft" &&
                  self.props.recordStatus !== "trash" &&
                  allLineItemsPriced === false
                ) {
                  // More pricing to do
                  Flagship.changeRecordStatus(
                    self.props.recordId,
                    "publish",
                    self.props.onStatusChange,
                  );

                  if (
                    moment
                      .unix(parseInt(self.props.record.extra3))
                      .isBefore(moment())
                  ) {
                    let updatedRecord = Object.assign({}, self.props.record);
                    let newDue = moment().businessAdd(2, "days");
                    updatedRecord.extra3 = newDue.format("X");
                    Flagship.post(
                      "save-record/" + self.props.record.id + "/",
                      {
                        record: updatedRecord,
                      },
                      function () {
                        Flagship.notify(
                          "New due date is " +
                            newDue.format("dddd, MM/DD") +
                            ".",
                        );
                      },
                    );
                  }
                }
              } else {
                self.props.updateLineItems([]);
              }
            },
          );
        } else {
          self.setState({
            loading: false,
          });
          Flagship.error(
            "Error getting line items from Flagship API server.",
            recordId,
            self.props.userId,
          );
        }
      },
      function (err) {
        if (
          self.unmounted === true ||
          requestId !== self.latestLineItemsRequestId ||
          self.props.recordId !== recordId
        ) {
          return;
        }

        self.setState({
          loading: false,
        });
        Flagship.error(
          "Error getting line items from Flagship API server: " + err,
          recordId,
          self.props.userId,
        );
      },
    );
  }

  onUpdatePricing(e, data, item) {
    if (this.props.accessLevel !== 2) {
      this.setState({
        viewingLineItem: item,
      });
      return;
    }

    if (
      this.props.userRole === "proposal_strategist" ||
      this.props.userRole === "admin"
    ) {
      this.setState({
        updatingPricing: item,
      });
    } else {
      this.setState({
        viewingLineItem: item,
      });
    }
  }

  onViewLineItem(e, data, item) {
    this.setState({
      viewingLineItem: item,
    });
  }

  onEditLineItem(e, data, item) {
    if (this.props.accessLevel !== 2) {
      return;
    }

    this.setState({
      editingLineItem: item,
    });
  }

  swapToEdit() {
    if (this.props.accessLevel !== 2) {
      return;
    }

    let item = this.state.viewingLineItem;
    let self = this;

    this.setState(
      {
        viewingLineItem: false,
      },
      function () {
        self.setState({
          editingLineItem: item,
        });
      },
    );
  }

  swapToView() {
    let item = this.state.editingLineItem;
    let self = this;

    this.setState(
      {
        editingLineItem: false,
      },
      function () {
        self.setState({
          viewingLineItem: item,
        });
      },
    );
  }

  onAddNew() {
    if (this.props.accessLevel !== 2) {
      return;
    }

    this.setState({
      addingLineItem: true,
    });
  }

  onChangeAssignee(item) {
    if (this.props.accessLevel !== 2) {
      return;
    }

    this.setState({
      editingAssignee: item,
    });
  }

  cancelAddNew() {
    this.setState({
      newLineItemService: null,
      newLineItemServiceNiceName: "",
      addingLineItem: false,
    });
  }

  closeModals() {
    this.setState(
      {
        updatingPricing: false,
        viewingLineItem: false,
        editingLineItem: false,
        editingAssignee: false,
      },
      this.props.onCloseModals,
    );
  }

  onLineItemAddModalChange(lineItemData) {
    this.setState({
      newLineItemData: lineItemData,
    });
  }

  onLineItemPricingModalChange(newPricing) {
    this.setState({
      editPricingFields: newPricing,
    });
  }

  onAddLineItem() {
    this.getLineItems();
    this.setState({
      addingLineItem: false,
    });
    if (typeof this.props.onAddLineItem === "function") {
      this.props.onAddLineItem();
    }
  }

  onUpdateLineItem() {
    let self = this;

    this.setState(
      {
        editingLineItem: false,
        editingAssignee: false,
        refreshing: true,
      },
      function () {
        self.getLineItems();
      },
    );
  }

  updateLineItemPricing(e) {
    if (this.props.accessLevel !== 2) {
      return;
    }

    let self = this;
    e.persist();
    Flagship.post(
      "line-item/update-pricing/" + self.state.updatingPricing.id,
      self.state.editPricingFields,
      function (response) {
        if (response.data.success === true) {
          Flagship.event(
            "update-line-item-pricing",
            {
              lineItemId: self.state.updatingPricing.id,
              lineItemKey: self.state.updatingPricing.line_item_key,
              lineItemName: self.state.updatingPricing.line_item_name,
              pricingFields: self.state.editPricingFields,
            },
            self.props.recordId,
            self.props.userId,
          );
          Flagship.notify("Pricing info updated.");
          self.setState(
            {
              updatingPricing: false,
              editingLineItem: false,
            },
            function () {
              self.getLineItems();
            },
          );
        } else {
          Flagship.error(
            "Error updating pricing info.",
            self.props.recordId,
            self.props.userId,
          );
        }
      },
      function (err) {
        Flagship.error(
          "Error updating pricing info: " + err,
          self.props.recordId,
          self.props.userId,
        );
      },
    );
  }

  duplicateLineItem(e, data, item) {
    if (this.props.accessLevel !== 2) {
      return;
    }

    let self = this;
    Flagship.post(
      "line-item/duplicate/" + item.id + "/" + self.props.recordId,
      {},
      function (response) {
        if (response.data.success === true) {
          Flagship.event(
            "create-line-item",
            item.line_item_name,
            self.props.recordId,
            self.props.userId,
          );
          Flagship.notify("Line item duplicated.", "success");
          self.closeModals();
          self.getLineItems();
        } else {
          Flagship.error(
            "Error duplicating line item.",
            self.props.recordId,
            self.props.userId,
          );
        }
      },
      function (err) {
        Flagship.error(
          "Error duplicating line item: " + err,
          self.props.recordId,
          self.props.userId,
        );
      },
    );
  }

  renderPrice(item) {
    let onUpdatePricing = this.onUpdatePricing.bind(this);

    if (item.price !== "" && item.price !== null) {
      return (
        <div>
          <Label
            onClick={(e, data) => {
              onUpdatePricing(e, data, item);
            }}
            className="pointer hover-dark-blue"
            color="blue"
          >
            {getFormattedValue(item.price, "money")}
          </Label>

          {item.cogs !== "" && item.cogs !== null ? (
            <Label
              className="pointer hover-dark-gray"
              onClick={(e, data) => {
                onUpdatePricing(e, data, item);
              }}
            >
              {getFormattedValue(item.cogs, "money")} COGS
            </Label>
          ) : null}
        </div>
      );
    } else {
      return (
        <Label
          onClick={(e, data) => {
            onUpdatePricing(e, data, item);
          }}
          color="green"
          className="pointer hover-dark-green"
          content="Needs Pricing"
        />
      );
    }
  }

  renderAsTable() {
    let onEditLineItem = this.onEditLineItem;
    let renderPrice = this.renderPrice;
    let currentRfpKey = this.props.recordKey;
    let onChangeAssignee = this.onChangeAssignee;

    let self = this;

    return (
      <Table className="line-item-table">
        <Table.Body>
          {this.state.lineItems.map(function (item, i) {
            let serviceNiceName = getServiceNiceName(item.line_item_type);
            return (
              <Table.Row
                key={"line-item-" + i}
                className="single-line-item-table-row"
              >
                <Table.Cell className="main-column">
                  <Link
                    to={
                      "/rfp/view/" +
                      currentRfpKey +
                      "/focus/" +
                      item.line_item_key
                    }
                    className="table-link"
                  >
                    {item.line_item_name}
                    {serviceNiceName !== item.line_item_name ? (
                      <div className="row-data-key">
                        ({serviceNiceName})<br />
                      </div>
                    ) : null}
                    <span className="row-data-key">
                      {item.line_item_key !== "" ? (
                        <Card.Meta>#{item.line_item_key}</Card.Meta>
                      ) : null}
                    </span>
                  </Link>
                </Table.Cell>
                <Table.Cell>{renderPrice(item)}</Table.Cell>
                <Table.Cell className="table-column-actions" textAlign="right">
                  <Popup
                    position="bottom left"
                    content="View"
                    trigger={
                      <Link
                        to={
                          "/rfp/view/" +
                          currentRfpKey +
                          "/focus/" +
                          item.line_item_key
                        }
                        className="view-line-item"
                      >
                        <Icon name="eye" circular />
                      </Link>
                    }
                  />
                  {self.props.userRole !== "ae" &&
                  self.props.accessLevel === 2 ? (
                    <Popup
                      position="bottom left"
                      content="Edit"
                      trigger={
                        <Icon
                          name="edit"
                          circular
                          onClick={(e, data) => {
                            onEditLineItem(e, data, item);
                          }}
                        />
                      }
                    />
                  ) : null}

                  {self.props.userRole !== "ae" &&
                  self.props.accessLevel === 2 ? (
                    <Popup
                      position="bottom left"
                      content="Duplicate"
                      trigger={
                        <Icon
                          name="copy"
                          circular
                          onClick={(e, data) => {
                            self.duplicateLineItem(e, data, item);
                          }}
                        />
                      }
                    />
                  ) : null}

                  {self.props.userRole !== "ae" &&
                  self.props.accessLevel === 2 ? (
                    <Popup
                      position="bottom left"
                      content={
                        empty(item.assignee)
                          ? "Unassigned"
                          : "Assigned to " +
                            item.first_name +
                            " " +
                            item.last_name
                      }
                      trigger={
                        empty(item.assignee) ? (
                          <Icon
                            color="black"
                            circular
                            name="user"
                            onClick={() => {
                              onChangeAssignee(item);
                            }}
                          />
                        ) : (
                          <Image
                            src={
                              Flagship.config.uploads +
                              (!empty(item.photo) ? item.photo : "someone.png")
                            }
                            size="mini"
                            className="circular assignee-image"
                            onClick={() => {
                              onChangeAssignee(item);
                            }}
                          />
                        )
                      }
                    />
                  ) : null}
                </Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    );
  }

  renderLineItems() {
    if (
      typeof this.state.lineItems === "object" &&
      this.state.lineItems.length === 0
    ) {
      return <div>No line items found.</div>;
    }

    let onEditLineItem = this.onEditLineItem;
    let renderPrice = this.renderPrice;
    let currentRfpKey = this.props.recordKey;
    let onChangeAssignee = this.onChangeAssignee;
    let userRole = this.props.userRole;

    let self = this;
    if (this.props.screenWidth >= 1030 && this.props.userViewAs === "list") {
      return this.renderAsTable();
    }

    return (
      <Card.Group>
        {this.state.lineItems.map(function (item, i) {
          let serviceNiceName = getServiceNiceName(item.line_item_type);
          return (
            <Card key={"line-item-" + i} className="single-line-item">
              <Card.Content>
                <Card.Header>
                  <Header as="h4">{item.line_item_name}</Header>
                </Card.Header>
                {serviceNiceName !== item.line_item_name ? (
                  <Card.Meta>
                    <small>({serviceNiceName})</small>
                  </Card.Meta>
                ) : null}
                {item.line_item_key !== "" ? (
                  <Card.Meta>
                    <small>#{item.line_item_key}</small>
                  </Card.Meta>
                ) : null}
                {(userRole === "dpm" ||
                userRole === "csm" ||
                userRole === "social" ||
                userRole === "admin") && self.props.accessLevel === 2 ? (
                  <div>
                    <Label
                      className="assignee-label"
                      onClick={() => {
                        onChangeAssignee(item);
                      }}
                    >
                      {empty(item.assignee) ? (
                        <div>
                          <Icon color="black" circular name="user" />
                          Unassigned
                          <Icon
                            name="caret down"
                            fitted
                            className="icon-down float-right"
                          />
                        </div>
                      ) : (
                        <div>
                          <Image
                            src={
                              Flagship.config.uploads +
                              (!empty(item.photo) ? item.photo : "someone.png")
                            }
                            size="mini"
                            className="circular assignee-image"
                          />
                          {item.first_name + " " + item.last_name}
                          <Icon
                            name="caret down"
                            fitted
                            className="icon-down float-right"
                          />
                        </div>
                      )}
                    </Label>
                  </div>
                ) : (
                  <div>
                    <Label className="assignee-label">
                      {empty(item.assignee) ? (
                        <div>
                          <Icon color="black" circular name="user" />
                          Unassigned
                        </div>
                      ) : (
                        <div>
                          <Image
                            src={
                              Flagship.config.uploads +
                              (!empty(item.photo) ? item.photo : "someone.png")
                            }
                            size="mini"
                            className="circular assignee-image"
                          />
                          {item.first_name + " " + item.last_name}
                        </div>
                      )}
                    </Label>
                  </div>
                )}
                <Card.Description>{renderPrice(item)}</Card.Description>
                <Card.Content extra>
                  <br />
                  {self.props.userRole !== "ae" &&
                  self.props.accessLevel === 2 ? (
                    <div className="ui two buttons line-item-actions">
                      <Link
                        to={
                          "/rfp/view/" +
                          currentRfpKey +
                          "/focus/" +
                          item.line_item_key
                        }
                      >
                        <Button basic primary>
                          View
                        </Button>
                      </Link>
                      <Button
                        basic
                        secondary
                        onClick={(e, data) => {
                          onEditLineItem(e, data, item);
                        }}
                      >
                        Edit
                      </Button>
                    </div>
                  ) : (
                    <div className="ui">
                      <Link
                        to={
                          "/rfp/view/" +
                          currentRfpKey +
                          "/focus/" +
                          item.line_item_key
                        }
                      >
                        <Button primary>View Details...</Button>
                      </Link>
                    </div>
                  )}
                </Card.Content>
              </Card.Content>
            </Card>
          );
        })}
      </Card.Group>
    );
  }

  renderUpdatePricingModal() {
    if (
      this.props.accessLevel !== 2 ||
      this.state.updatingPricing === false
    ) {
      return null;
    } else {
      return (
        <LineItemPricingModal
          open={true}
          cancelUpdate={this.closeModals.bind(this)}
          updateLineItemPricing={this.updateLineItemPricing.bind(this)}
          lineItemId={
            !empty(this.state.updatingPricing.id)
              ? this.state.updatingPricing.id
              : false
          }
          recordId={this.props.recordId}
          onChange={this.onLineItemPricingModalChange}
          lineItem={this.state.updatingPricing}
        />
      );
    }
  }

  renderViewLineItemModal() {
    if (this.state.viewingLineItem === false) {
      return null;
    } else {
      return (
        <LineItemViewModal
          open={true}
          cancelUpdate={this.closeModals.bind(this)}
          lineItemId={
            !empty(this.state.viewingLineItem.id)
              ? this.state.viewingLineItem.id
              : false
          }
          recordId={this.props.recordId}
          lineItem={this.state.viewingLineItem}
          swapToEdit={this.swapToEdit}
          getLineItems={this.getLineItems}
          duplicateLineItem={this.duplicateLineItem}
          accessLevel={this.props.accessLevel}
        />
      );
    }
  }

  renderEditLineItemModal() {
    if (
      this.props.accessLevel !== 2 ||
      this.state.editingLineItem === false
    ) {
      return null;
    } else {
      return (
        <LineItemEditModal
          open={true}
          cancelUpdate={this.closeModals.bind(this)}
          lineItemId={
            !empty(this.state.editingLineItem.id)
              ? this.state.editingLineItem.id
              : false
          }
          recordId={this.props.recordId}
          lineItem={this.state.editingLineItem}
          swapToView={this.swapToView}
          onChange={this.onLineItemEditModalChange}
          onUpdateLineItem={this.onUpdateLineItem}
          accessLevel={this.props.accessLevel}
        />
      );
    }
  }

  renderAddLineItemModal() {
    if (this.props.accessLevel !== 2 || this.state.addingLineItem === false) {
      return null;
    } else {
      return (
        <LineItemAddModal
          open={true}
          cancelAddNew={this.cancelAddNew.bind(this)}
          recordId={this.props.recordId}
          onChange={this.onLineItemAddModalChange}
          name={this.state.newLineItemName}
          service={this.state.newLineItemService}
          serviceNiceName={this.state.newLineItemServiceNiceName}
          newLineItemService={this.state.newLineItemService}
          onAddLineItem={this.onAddLineItem}
          accessLevel={this.props.accessLevel}
        />
      );
    }
  }

  renderAssignLineItemModal() {
    if (this.props.accessLevel !== 2 || this.state.editingAssignee === false) {
      return null;
    } else {
      return (
        <LineItemAssignModal
          open={true}
          recordId={this.props.recordId}
          data={this.state.editingAssignee}
          onChange={this.onChangeAssignee}
          cancelUpdate={this.closeModals.bind(this)}
          onUpdateLineItem={this.onUpdateLineItem}
          onChangeAssignee={this.props.onChangeAssignee}
          accessLevel={this.props.accessLevel}
        />
      );
    }
  }

  changeViewAs(e, data) {
    this.props.actions.changeViewAs(data.value);

    // Update user preference in DB
    Flagship.post("user-view-as/" + this.props.userId, { viewAs: data.value });
  }

  render() {
    if (this.props.parentMode === "view") {
      return (
        <div className="line-item-box">
          <Divider hidden />
          <Header as="h3">
            Line Items
            <Dropdown
              text="View As..."
              className="change-view-as"
              options={[
                {
                  key: "cards",
                  value: "cards",
                  text: "Cards",
                },
                {
                  key: "list",
                  value: "list",
                  text: "List",
                },
              ]}
              onChange={this.changeViewAs}
            />
          </Header>
          {this.state.loading === true ? (
            <Loader
              color="blue"
              className="flagship-loader"
              active
              inline="centered"
            />
          ) : (
            <div>
              {this.renderLineItems()}
              <br />
              {this.props.userRole !== "ae" &&
              this.props.accessLevel === 2 ? (
                <div className="pulsing-button-wrap">
                  {this.props.recordStatus === "proposal" ||
                  this.props.recordStatus === "closed" ||
                  this.props.recordStatus === "insertion"
                    ? (
                      <div>
                        <h3>Reopen RFP</h3>
                        <p className="gray-text">
                          You can reopen this RFP by adding another line item.
                          This will change the RFP status back to "Needs
                          Pricing."{" "}
                          {moment
                            .unix(parseInt(this.props.record.extra3))
                            .isBefore(moment()) ? (
                            <span>
                              The due date will also be updated to{" "}
                              {moment()
                                .businessAdd(2, "days")
                                .format("dddd, MM/DD")}
                              .
                            </span>
                          ) : null}
                        </p>
                      </div>
                    )
                    : null}
                  {this.props.userMarket === "Chicago" ||
                  this.props.instance === "SHIFT" ? (
                    <Button
                      primary
                      icon="plus"
                      content={
                        this.state.lineItems.length
                          ? "Add Another Line Item..."
                          : "Add a Line Item..."
                      }
                      onClick={this.onAddNew}
                      className={
                        this.state.lineItems.length
                          ? "pulsing-button-normal"
                          : "pulsing-button-pulsing"
                      }
                    />
                  ) : (
                    <small className="gray-text">
                      Line items can no longer be added here. Please use Advisr.
                    </small>
                  )}
                </div>
              ) : (
                <div className="gray-text">
                  You cannot add line items to this RFP.
                </div>
              )}
            </div>
          )}
          {this.renderAddLineItemModal()}
          {this.renderUpdatePricingModal()}
          {this.renderViewLineItemModal()}
          {this.renderEditLineItemModal()}
          {this.renderAssignLineItemModal()}
        </div>
      );
    } else {
      return null;
    }
  }
}

function mapStateToProps(state) {
  return {
    username: state.main.username,
    userId: state.main.userId,
    userRole: state.main.userRole,
    screenWidth: state.main.screenWidth,
    userViewAs: state.main.userViewAs,
    userMarket: state.main.userMarket,
    instance: state.main.instance,
    accessLevel: state.main.accessLevel,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LineItemBox);



// WEBPACK FOOTER //
// ./src/components/misc/LineItemBox.js